import { Component, OnInit } from '@angular/core';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { Location } from '@angular/common';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-company-side-bar-page',
  templateUrl: './company-side-bar-page.component.html',
  styleUrls: ['./company-side-bar-page.component.scss'],
})
export class CompanySideBarPageComponent implements OnInit {
  companyOverview: any;
  productList: any;
  loginEmail: string;
  isAddedInFollowList: any = false;
  company_url: any;
  overview = true;
  funding = true;
  financials = true;
  traction = true;
  people = true;
  news = true;
  display = false;
  roc: boolean = true;
  activeTab: String;
  url: String
  cin: String;
  companyName: String;
  isPremium: boolean = false;
  isFree: boolean = false;
  plan: string;
  isAdvance: boolean = false;
  timeline: boolean = true;
  deviceType;
  items: MenuItem[] | undefined;

  constructor(
    private companyService: CompanyService,
    private router: Router,
    private loginSignupService: LoginSignupService,
    private commonService: CommonService,
    private toastService: ToastService,
    private tansactionService: TansactionService,
    private localStorageService: LocalStorageService,
    private _location: Location,
  ) {
    this.deviceType = localStorageService.getItem('deviceType');
    this.router.events
      .pipe(
        filter(
          (e) =>
            e instanceof ActivationEnd &&
            Object.keys(e.snapshot.params).length > 0
        ),
        map((e) => (e instanceof ActivationEnd ? e.snapshot.params : {}))
      )
      .subscribe((data) => {
        this.url = this.router.url;
        this.activeTab = this.url.split("/")[3];
        this.initializeMenuItems();
        this.updateTabVisibility(data);
      });
    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }
  }

  updateTabVisibility(data) {
    const tab = data?.tab;
    this.overview = tab?.includes('overview') || false;
    this.funding = tab?.includes('funding') || false;
    this.financials = tab?.includes('financials') || false;
    this.traction = tab?.includes('traction') || false;
    this.people = tab?.includes('people') || false;
    this.news = tab?.includes('news') || false;
    this.roc = tab?.includes('roc') || false;
    this.timeline = tab?.includes('timeline') || false;
    if (tab?.includes('traction') || tab?.includes('news') || tab?.includes('roc') || tab?.includes('timeline')) {
      this.commonService.putProductData(null);
    }
  }


  ngOnInit(): void {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    this.companyService.sharedData$.subscribe((data) => {
      if (data) {
        this.companyOverview = data;
        this.company_url = this.companyOverview.companyUrl
        this.cin = this.companyOverview.cin;
        this.companyName = this.companyOverview.name;
        this.isAddedInFollowList = this.commonService.isInFollowlist(
          this.companyOverview._id
        );
        this.initializeMenuItems();
      }
    });
    this.getHistoricalData();
    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }
  }
  initializeMenuItems() {
    this.items = [
      {
        label: 'Overview',
        routerLink: ['/company', this.companyOverview?.companyUrl, 'overview'],
        command: () => {
          this.selectTab('overview');
        },
      },
      {
        label: 'Funding',
        routerLink: ['/company', this.companyOverview?.companyUrl, 'funding'],
        command: () => {
          this.selectTab('funding');
        },
      },
      {
        label: 'Financial',
        routerLink: ['/company', this.companyOverview?.companyUrl, 'financials'],
        command: () => {
          this.selectTab('financials');
        },
      },
      {
        label: 'People',
        routerLink: ['/company', this.companyOverview?.companyUrl, 'people'],
        command: () => {
          this.selectTab('people');
        },
      },
      {
        label: 'Roc',
        routerLink: ['/company', this.companyOverview?.companyUrl, 'roc'],
        command: () => {
          this.selectTab('roc');
        },
      },
      {
        label: 'News',
        routerLink: ['/company', this.companyOverview?.companyUrl, 'news'],
        command: () => {
          this.selectTab('news');
        },
      },
      {
        label: 'Timeline',
        routerLink: ['/company', this.companyOverview?.companyUrl, 'timeline'],
        command: () => {
          this.selectTab('timeline');
        },
      },
    ];
  }


  getIcon(label: string): string {
    switch (label) {
      case 'Overview':
        return 'assets/company-tab-img/overview.png';
      case 'Funding':
        return 'assets/company-tab-img/funding.png';
      case 'Financial':
        return 'assets/company-tab-img/financial.png';
      case 'People':
        return 'assets/company-tab-img/people.png';
      case 'Roc':
          return 'assets/company-tab-img/company-document.png';
      case 'News':
        return 'assets/company-tab-img/news.png';
      case 'Timeline':
        return 'assets/company-tab-img/timeline.png';
      default:
        return ''; // Fallback icon if needed
    }
  }

  getHistoricalData() {
    let request = { cin: this.cin, autoScroll: true };
    this.companyService
      .getCompanyHistoricalDetails(request)
      .then((data: any) => {
        if (data) {
          this.productList = data.product_list_arr;
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  selectTab(tab) {
    this.activeTab = tab;
    this.companyService.updateAutoScroll(true);
    this.router.navigate(['/company/' + this.company_url + '/' + tab], { replaceUrl: true });
  }

  goBack(event: MouseEvent) {
    event.preventDefault();  // Prevent the default anchor behavior
    this._location.back();
  }

  followCompany() {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    if (
      this.loginEmail !== undefined &&
      this.loginEmail !== '' &&
      this.loginEmail !== null
    ) {
      this.isAddedInFollowList = this.commonService.addToFollowList(
        this.companyOverview._id
      );
      let request = {
        cin: this.companyOverview.cin,
      };
      this.commonService
        .addFollowInCompanyList(request)
        .then((data: any) => {
          this.isAddedInFollowList = this.commonService.isInFollowlist(
            this.companyOverview._id
          );
          // window.location.reload();
        })
        .catch((err: any) => {
          // console.log(err)
        });
    } else {
      this.localStorageService.setItem("redirect_url", this.router.url);
      this.router.navigate(['/user/login']);
    }
  }

  showDialog() {
    this.display = true;
  }

  showDownload = false;
  showDownloadPopup() {
    this.showDownload = true;
  }

  addToCart(sku) {
    if (
      this.loginEmail == undefined ||
      this.loginEmail == '' ||
      this.loginEmail == null
    ) {
      this.localStorageService.setItem("redirect_url", this.router.url);
      this.router.navigate(['/user/login']);
    } else {
      let currentOption;
      currentOption = {
        sku: sku,
      };
      this.tansactionService.addProductToCart(currentOption).then(
        (data: any) => {
          if (this.isPremium == true || this.isAdvance == true) {
            this.toastService.addSingle(
              'success',
              'Email Sent',
              'Please check your email.'
            );
          } else {
            this.toastService.addSingle(
              'success',
              'Item added to cart',
              'Make payment to complete this transaction.'
            );
          }
        },
        (err) => {
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      );
    }
  }
  getProductShortName(name) {
    return name.replace(' - ' + this.companyName + '.pdf', '');
  }


  navigateToIndustryReport(name, sku) {
    let isReport = false;
    this.router.navigate([`/company/${this.companyName}/product/${this.getProductShortName(name)}/${sku}/${isReport}`]);
  }
}
